import React, { useState, useEffect } from "react";
import "../pages.scss";
import "./sentimentChartTooltip.scss"
import colors from "../styles/_colors.scss";
import Sentiment from "../Sentiment/Sentiment";
import {NEGATIVE_POLARITY_LIMIT, POSITIVE_POLARITY_LIMIT, USER_EVENTS} from "../constants";
import Metrics from '../services/Metrics';

function Lerp(start, end , t) {
    return start * (1 - t) + end * t;
}

const SentimentChartTooltip = ({ tooltipState, isDetailedView }) => {
    const [style, setStyle] = useState({ left: 0, top: 0 });
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    let position = {
        left: style.left,
        bottom: 100
    };

    if (isDetailedView) {
        position = {
            left: style.left,
            bottom: 500
        }
    }

    const mouseMoveHandler = (event) => {
        const rect = event.target.getBoundingClientRect();
        setMousePosition({
            x: event.clientX - rect.left
        });
    };

    useEffect(() => {
        document.addEventListener('mousemove', mouseMoveHandler);

        Metrics.track(USER_EVENTS.HOVERED_SENTIMENT_GRAPH);

        return () => {
            document.removeEventListener('mousemove', mouseMoveHandler);
        }
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            const x = Lerp(style.left, mousePosition.x, 0.1);
            const y = Lerp(style.top, mousePosition.y, 0.1);

            setStyle({ left: x, top: y });
        }, 10);

        return () => {
            clearInterval(interval);
        };
    }, [mousePosition, style]);

    if (!tooltipState.isVisible) return null;

    const {data, summary, timestamp} = tooltipState;

    let [hours, minutes] = timestamp.split(':').map(Number);
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    const timestampDisplay = hours + ":" + minutes;

    let backgroundColor;
    let sentimentString;
    if (data < NEGATIVE_POLARITY_LIMIT) {
        backgroundColor = colors.negativeInfo;
        sentimentString = "Negative";
    } else if (data > POSITIVE_POLARITY_LIMIT) {
        backgroundColor = colors.positiveInfo;
        sentimentString = "Positive";
    } else {
        backgroundColor = colors.neutralInfo;
        sentimentString = "Neutral";
    }

    return (
        <div className={"sentiment-chart-tooltip"} style={position}>
            <div className={"tooltip-banner"} style={{backgroundColor}}>
                <div className={"timestamp"}>
                    {timestampDisplay}
                </div>
                <div className={"overall-sentiment sentiment-score"}>
                    <Sentiment sentiment={sentimentString}/>
                </div>
            </div>
            <div className={"sentiment-summary"}>
                {summary}
            </div>
        </div>
    );
}

export default SentimentChartTooltip;